import { render, staticRenderFns } from "./AddAnnouncement.vue?vue&type=template&id=0cb58be2&scoped=true&"
import script from "./AddAnnouncement.vue?vue&type=script&lang=js&"
export * from "./AddAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./AddAnnouncement.vue?vue&type=style&index=0&id=0cb58be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb58be2",
  null
  
)

export default component.exports